import Field from "@/includes/fields/Field";
import {State} from "@/store/index";

export const mutations = {
    aceitarTermos(state: State) {
        state.aceite = true
    },

    clearAll(state: State) {
        Object.values(state.formulario).forEach((formulario: any) =>
            formulario.fields.map((field: Field) => field.clear())
        )
    },

    setFormulariosId(state: State, id: string) {
        state.formularioId = id
    },

    setFormularioPerfil(state: State, fields: Array<Field>) {
        state.formulario.perfil.fields = fields
    },

    setFormularioImpacto(state: State, fields: Array<Field>) {
        state.formulario.impacto.fields = fields
    },

    setFormularioImpactoEconomico(state: State, fields: Array<Field>) {
        state.formulario.impactoEconomico.fields = fields
    },

    setFormularioFinal(state: State, fields: Array<Field>) {
        state.formulario.final.fields = fields
    },

    setUsuario(state: State, usuario: any) {
        state.usuario = usuario
    },

    logout(state: State) {
        state.usuario = null
    },
}